<template>
  <div class="title-player-container" v-if="contentSameShowCase.length > 1">
    <div
      v-if="title"
      class="row no-gutters justify-start align-start title-content"
    >
      <v-icon left>{{ mdiYoutube }}</v-icon>
      <div>
        <h5>{{ title }}</h5>
      </div>
    </div>
    <div v-if="showListContents">
      <v-divider />
      <div class="list-content">
        <div class="pa-4">
          <span>Others video</span>
        </div>
        <v-sheet
          v-if="
            $vuetify.breakpoint.name === 'xl' ||
            $vuetify.breakpoint.name === 'lg'
          "
          class="mx-auto"
        >
          <v-slide-group multiple show-arrows>
            <v-slide-item
              v-for="(content, idx) in contentSameShowCase"
              :key="idx"
              v-slot="{ active, toggle }"
              class="wow fadeInLeft"
            >
              <div
                :id="`${content.showcase_id}`"
                class="content-showcase"
                @click="onSelectContent(content)"
              >
                <v-img
                  width="200px"
                  @click="toggle"
                  class="mx-2"
                  :input-value="active"
                  active-class="purple white--text"
                  :src="content.url_poster"
                  :aspect-ratio="16 / 9"
                >
                </v-img>
                <span class="title-other-content">
                  {{ content.title }}
                </span>
                <div class="overlay"></div>
              </div>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
        <div class="row justify-center" v-else>
          <div
            v-for="(content, idx) in contentSameShowCase"
            class="content-showcase pa-2"
            :id="`${content.showcase_id}`"
            @click="onSelectContent(content)"
            :key="idx"
          >
            <v-img
              width="250px"
              class="mx-2"
              active-class="purple white--text"
              :src="content.url_poster"
              :aspect-ratio="16 / 9"
            >
            </v-img>
            <span class="title-other-content">
              {{ content.title }}
            </span>
            <div class="overlay"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { call, sync } from "vuex-pathify";
import _ from "lodash";
import { mdiYoutube } from "@mdi/js";

export default {
  name: "ContentSameShowcase",
  props: {
    showcaseId: {
      type: String,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    typeShowCase: {
      type: Number,
      default: -1,
    },
  },
  async created() {
    if (!this.contentsShowcase || this.contentsShowcase.length === 0) {
      await this.getAllShowcases();
    }
  },
  data() {
    return {
      showListContents: true,
      mdiYoutube: mdiYoutube,
    };
  },
  watch: {
    showcaseId(newVal, oldVal) {
      this.addBorder(newVal);
      this.removeBorder(oldVal);
    },
  },
  computed: {
    contentsShowcase: sync("showcase/contentShowcase"),
    contentSameShowCase() {
      return _.filter(this.contentsShowcase, {
        type_showcase: this.typeShowCase,
      });
    },
  },
  methods: {
    getAllShowcases: call("showcase/getAllShowcase"),
    onSelectContent(data) {
      this.$emit("selectContent", data);
    },
    addBorder(showcase_id) {
      let elShowcase = document.getElementById(showcase_id);
      if (elShowcase) {
        elShowcase.classList.add("border-active");
      }
    },
    removeBorder(showcase_id) {
      let elShowcase = document.getElementById(showcase_id);
      if (elShowcase) {
        elShowcase.classList.remove("border-active");
      }
    },
  },
  mounted() {
    this.addBorder(this.showcaseId);
  },
};
</script>

<style scoped>
.border-active {
  border: 2px #1e5637 solid;
  background-color: #40b272;
  pointer-events: none;
}
</style>
